import {
    startAnim,
    isFunction,
    extend,
    getAllChildNodes
} from '../util/util';

/**
 * 三维线的流动动画（ UV 偏移）
 * @param  {ht.Node}        nodes       - 节点的组合
 * @param  {Number}   step        - UV 偏移步长
 * @param  {String}         uvPosition  - 要进行 UV 偏移的位置
 * @param  {Boolean}        isU         - 是否是偏移 U 位
 * @return {[type]}            [description]
 */
export function runUVFlowAnim(nodes, step = 0.05, uvPosition = 'shape3d.uv.offset', isU = true) {
    let lastTime = new Date().getTime();

    return startAnim({
        interval: 20,
        frames: Infinity,
        action: () => {
            let time = new Date().getTime(),
                deltaTime = time - lastTime,
                offset = step * (deltaTime / 20);
            lastTime = time;

            nodes.eachChild(node => {
                if (node.s('3d.visible')) {
                    let uv = node.s(uvPosition) || [0, 0];
                    if (isU)
                        node.s(uvPosition, [uv[0] + offset, uv[1]]);
                    else
                        node.s(uvPosition, [uv[0], uv[1] + offset]);
                }
            });
        }
    });
}

/**
 * 三维流光数字的动画
 * @param  {ht.Node} nodes        - 流动数字的数据节点组
 * @param  {Number} elevationStep - 流动步长
 * @param  {Array} range          - 范围[xmin, xmax, zmin, zmax]
 * @return {[type]}               [description]
 */
export function runStreamNumbersAnim(nodes, step = 1, range) {
    // 节点初始化处理
    nodes.eachChild(node => {
        let elevation = node.getElevation();
        node.s('shape3d.opacity', 0);
        node.a({
            'init.elevation': elevation,
            'dir': 1,
            'opacityStep': Math.floor(5 * Math.random()) / 100
        });
    });
    return startAnim({
        interval: 20,
        frames: Infinity,
        action: () => {
            nodes.eachChild((node, i) => {
                let elevation = node.getElevation();
                let opacity = node.s('shape3d.opacity');
                node.s('shape3d.opacity', opacity + node.a('dir') * node.a('opacityStep'));
                node.setElevation(elevation + step);
                if (node.s('shape3d.opacity') > 1) {
                    node.a('dir', -1);
                }
                if (node.s('shape3d.opacity') < 0) {
                    node.setElevation(node.a('init.elevation'));
                    node.a('dir', 1);
                    node.s('shape3d.opacity', 0);
                    // 根据区间随机修改位置
                    if (range && ht.Default.isArray(range)) {
                        let _x = Math.floor(range[0] + (range[1] - range[0]) * Math.random()),
                            _y = Math.floor(range[2] + (range[3] - range[2]) * Math.random());
                        node.setX(_x);
                        node.setY(_y);
                    }
                }
            });
        }
    });
}

/**
 * 面板的裁剪动画
 * @param {*} node 
 * @param {*} options 
 */
export function runClipPanelAnim(node, options = {}) {
    return startAnim({
        delay: options.delay || 0,
        duration: (options.duration && options.duration !== 0) ? options.duration : 1000,
        easing: t => t,
        finishFunc: () => {
            isFunction(options.finishFunc) && options.finishFunc();
        },
        action: (v, t) => {
            node.s('clip.percentage', options.isHide ? (1 - v) : v);
        }
    });
}

/**
 * 面板沿着 X 轴的缩放动画
 * @param {*} node 
 * @param {*} options 
 */
export function runOpenPanelAnimX(node, options = {}) {
    node.setScaleY(0.01);
    return startAnim({
        delay: options.delay || 0,
        duration: 1000,
        easing: options.easing1 ? options.easing1 : t => t,
        finishFunc: () => {
            ht.Default.startAnim({
                duration: (options.duration && options.duration !== 0) ? options.duration : 1000,
                easing: options.easing2 ? options.easing2 : t => t,
                finishFunc: () => {
                    isFunction(options.finishFunc) && options.finishFunc();
                },
                action: (v, t) => {
                    let scaleY = v === 0 ? 0.01 : v;
                    node.setScaleY(scaleY);
                }
            });
        },
        action: (v, t) => {
            node.setScaleX(v);
        }
    });
}

/**
 * 面板沿着 Y 轴的缩放动画
 * @param {*} node 
 * @param {*} options 
 */
export function runOpenPanelAnimY(node, options = {}) {
    node.setScaleX(0.01);
    return startAnim({
        delay: options.delay || 0,
        duration: 1000,
        easing: options.easing1 ? options.easing1 : t => t,
        finishFunc: () => {
            ht.Default.startAnim({
                duration: (options.duration && options.duration !== 0) ? options.duration : 1000,
                easing: options.easing2 ? options.easing2 : t => t,
                finishFunc: () => {
                    isFunction(options.finishFunc) && options.finishFunc();
                },
                action: (v, t) => {
                    let scaleX = v === 0 ? 0.01 : v;
                    node.setScaleX(scaleX);
                }
            });
        },
        action: (v, t) => {
            node.setScaleY(v);
        }
    });
}



/**
 * 面板沿着 X 轴的缩放动画
 * @param {*} node 
 * @param {*} options 
 */
export function runClosePanelAnimX(node, options = {}) {
    node.setScaleX(1);
    node.setScaleY(1);
    return startAnim({
        delay: options.delay || 0,
        duration: 1000,
        easing: options.easing1 ? options.easing1 : t => t,
        finishFunc: () => {
            ht.Default.startAnim({
                duration: (options.duration && options.duration !== 0) ? options.duration : 1000,
                easing: options.easing2 ? options.easing2 : t => t,
                finishFunc: () => {
                    isFunction(options.finishFunc) && options.finishFunc();
                },
                action: v => {
                    node.setScaleY(1 - v);
                }
            });
        },
        action: (v, t) => {
            node.setScaleX(1 - v);
        }
    });
}

/**
 * 面板沿着 Y 轴的缩放动画
 * @param {*} node 
 * @param {*} options 
 */
export function runClosePanelAnimY(node, options = {}) {
    node.setScaleX(1);
    node.setScaleY(1);
    return startAnim({
        delay: options.delay || 0,
        duration: 1000,
        easing: options.easing1 ? options.easing1 : t => t,
        finishFunc: () => {
            ht.Default.startAnim({
                duration: (options.duration && options.duration !== 0) ? options.duration : 1000,
                easing: options.easing2 ? options.easing2 : t => t,
                finishFunc: () => {
                    isFunction(options.finishFunc) && options.finishFunc();
                },
                action: v => {
                    node.setScaleX(1 - v);
                }
            });
        },
        action: (v, t) => {
            node.setScaleY(1 - v);
        }
    });
}

/**
 * 表格的滚动
 * @param {*} table 
 * @param {*} options 
 */
export function runTableScrollAnim(table, options = {}, scrollAnim) {
    const tableData = table.a('ht.dataSource');
    const rowHeight = table.a('ht.rowHeight');
    const dir = options.dir || 1;
    if(dir === -1) {
        table.a('ht.translateY', -rowHeight);
    }

    const params = {
        delay: (options.delay || options.delay === 0) ? options.delay : 3000,
        duration: (options.duration || options.duration === 0) ? options.duration : 1000,
        easing: t => t,
        action: v => {
            table.a({
                'ht.translateY': (dir === 1 ? (-rowHeight * v) : (-rowHeight * (1 - v)))
            });
        },
        finishFunc: () => {
            let nextData = [];
            nextData = tableData;
            if(dir === 1) {
                let firstElement = nextData.shift();
                if (options.loop) {
                    nextData.push(firstElement);
                }
            }
            else {
                let lastElement = nextData.pop();
                if (options.loop) {
                    nextData.unshift(lastElement);
                }

            }
            table.a({
                'ht.dataSource': nextData,
                'ht.translateY': dir === 1 ? 0 : -rowHeight
            });
            runTableScrollAnim(table, options, scrollAnim);
        }
    }
    scrollAnim = startAnim(params);

    return scrollAnim;
}


/**
 * 信息列表展开或收起动画
 * @export
 * @param {ht.List} list - 要展开或收起的信息列表
 * @param {Function} callback - 结束后的处理函数
 * @param {Object} option - 参数配置，可以配置动画时间长度和两个之间的时间间隔以及是展开还是收起，默认是展开
 */
export function expandCollapseListAnim(list, callback, option = {}) {
    const len = list.size();
    let isExpand = option.actionType ? option.actionType === 'expand' : true;
    let delayTime = [];
    let anims = [];
    if (option.delay && isArray(option.delay)) {
        delayTime = option.delay;
    } else {
        let defaultDelay = option.delay || 10;
        for (let i = 0; i < len; i++) {
            delayTime[i] = defaultDelay * i;
        }
    }
    list.each((node, index) => {
        let currentPercentage = node.s('clip.percentage');
        let dp = isExpand ? (1 - currentPercentage) : -currentPercentage;
        let animDelayTime = (delayTime[index] !== 0 && !delayTime[index]) ? 500 : delayTime[index];
        let param = {
            delay: animDelayTime,
            duration: option.duration || 1500,
            finishFunc: () => {
                if (isExpand && index === len - 1) {
                    isFunction(callback) && callback();
                }
                if (!isExpand && index === 0) {
                    isFunction(callback) && callback();
                }
            },
            action: v => {
                node.s('clip.percentage', currentPercentage + dp * v);
            }
        };
        let anim = ht.Default.startAnim(param);
        anims.push(anim);
    });

    return anims;
}

/**
 * 左右移入动画
 * @param {*} node 
 * @param {*} options
 */
export function fadeIn(node, options = {}) {
    if(node.a('anim')) return;

    options = extend({
        duration: 1000,
        easing: t => t * t,
        callback: () => {},
        filterFunc: () => true,
        left: true
    }, options);

    const {
        left,
        duration,
        easing,
        callback,
    } = options;

    const rect = node.getRect();
    const x = node.getX();
    const datas = getAllChildNodes(node);
    let startX = left ? x - rect.width : x + rect.width;
    if(node.a('hadAnim')) {
        startX = x;
    }
    node.a('anim', true);

    return startAnim({
        duration: duration,
        easing: easing,
        action: v => {
            left ? node.setX(startX + rect.width * v) : node.setX(startX - rect.width * v);
            if (v > 0.2) {
                node.s('2d.visible', true);
            }
            datas.forEach(n => {
                n.s('opacity', v);
            });
        },
        finishFunc() {
            node.a('anim', false);
            callback && callback();
        }
    });
}

/**
 * 左右移出动画
 * @param {*} node 
 * @param {*} options
 */
export function fadeOut(node, options = {}) {
    if(node.a('anim')) return;

    options = extend({
        duration: 1000,
        easing: t => t * t,
        callback: () => {},
        filterFunc: () => true,
        left: true
    }, options);

    const {
        left,
        duration,
        easing,
        callback
    } = options;

    const rect = node.getRect();
    const x = node.getX();
    const datas = getAllChildNodes(node);

    node.a('anim', true);

    return startAnim({
        duration: duration,
        easing: easing,
        action: v => {
            left ? node.setX(x - rect.width * v) : node.setX(x + rect.width * v);
            if (v > 0.8) {
                node.s('2d.visible', false);
            }
            datas.forEach(n => {
                n.s('opacity', (1 - v));
            });
        },
        finishFunc() {
            node.a('anim', false);
            node.a('hadAnim', true);
            callback && callback();
        }
    });
}

/**
 * GIS 路径点漫游
 * @param {*} map 
 * @param {*} paths 
 * @param {*} index 
 * @param {*} cb 
 */
export function runRoamByPath(map, paths, index, cb) {
    const info = paths[index];
    map.flyTo(info, () => {
        if(index < paths.length) {
            index++;
            runRoamByPath(map, paths, index, cb);
        }
        else {
            cb && cb();
        }
    });
}

/**
 * 节点数值增长动画
 * @param {*} node 
 * @param {*} values 
 * @param {*} option
 */
export function runNumberGrowth(node, values, fixed = 0, option = {}) {
    const names = Object.keys(values);
    return startAnim({
        delay: option.delay || 0,
        duration: option.duration || 1000,
        easing: option.easing ? option.easing : (t => t),
        action: v => {
            names.forEach(name => {
                node.a(name, (values[name] * v).toFixed(fixed));
            });
        },
        finishFunc: option.finishFunc
    });
}

// export function turnPanelAnim(panels, datas, callback, option = {}, i = 0) {
//     if(i === 0) {
//         startAnim({
//             delay: 0,
//             duration: option.duration,
//             easing: t => t,
//             action: v => {
//                 panels[i].setScaleX(1 - v);
//             },
//             finishFunc() {
//                 panels[i].a(datas[i]);
//                 turnPanelAnim(panels, data, callback, i++);
//             }
//         });
//     }
//     else if(i ==- panels.length - 1){

//     }
//     else {
//         startAnim({
//             delay: 500,
//             duration: option.duration,
//             easing: t => t,
//             action: v => {
//                 panels[i].setScaleX(1 - v);
//             },
//             finishFunc() {
//                 panels[i].a(datas[i]);
//                 turnPanelAnim(panels, data, callback, i++);
//             }
//         });
//     }
// }